import { handleActions } from 'redux-actions';

import { increment, decrement } from 'shared/redux/helpers/counter';

import { NAMES as SERVER_VIDEOS_LIST } from 'dashboard/redux/server/actions/videos/list';
import { NAMES as SERVER_VIDEOS_SEARCH } from 'dashboard/redux/server/actions/videos/search';
import { NAMES as SERVER_VIDEO_GET } from 'dashboard/redux/server/actions/video/get';


export default handleActions({
  [SERVER_VIDEOS_LIST.START]: increment,
  [SERVER_VIDEOS_SEARCH.START]: increment,
  [SERVER_VIDEO_GET.START]: increment,

  [SERVER_VIDEOS_LIST.SUCCESS]: decrement,
  [SERVER_VIDEOS_SEARCH.SUCCESS]: decrement,
  [SERVER_VIDEO_GET.SUCCESS]: decrement,

  [SERVER_VIDEOS_LIST.FAIL]: decrement,
  [SERVER_VIDEOS_SEARCH.FAIL]: decrement,
  [SERVER_VIDEO_GET.FAIL]: decrement,
}, 0);



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/videos/active-requests.js